import * as React from 'react';
import { useState } from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { InputAdornment, MenuItem, TextField } from '@mui/material';
import toast from 'react-hot-toast';
import { createRSSLink } from '../../../services/Service';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'background.paper',
  border: '1px solid #000',
  borderRadius: '8px',
  boxShadow: 24,
  displey: 'flex',
  flexDirection: 'column',
  gap: '12px',
  p: 4,
  maxHeight: '95vh',
  overflow: 'auto',
  '@media (max-width: 640px)': {
    width: '95vw',
  },
};

const mode = '';

const initFieldValue = {
  url: '',
  category: '',
};

export default function AddRSSLinkModal({ open, onClose }) {
  const [fieldValue, setFieldValue] = React.useState(initFieldValue);
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const handleClose = () => {
    setFieldValue(initFieldValue);
    onClose();
  };

  const onSubmit = async () => {
    setIsSubmitting(true);
    try {
      const res = await createRSSLink(fieldValue);
      if (res.status === 200) {
        toast.success(res.data.message);
        handleClose();
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      open={open}
      // onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography
          variant="h4"
          gutterBottom
          sx={{ marginBottom: '16px', fontSize: '30px', fontWeight: 700, color: '#19c25f' }}
        >
          Add RSS Link
        </Typography>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <TextField
            value={fieldValue.url}
            onChange={(e) => setFieldValue((prev) => ({ ...prev, url: e.target.value }))}
            required
            label="URL"
            name="url"
            size="small"
            type="url"
            fullWidth
            variant="outlined"
            disabled={isSubmitting}
            // error={error}
            // helperText={error ? 'Please enter a valid card name(min 3 char)' : ''}
          />
          <TextField
            value={fieldValue.category}
            onChange={(e) => setFieldValue((prev) => ({ ...prev, category: e.target.value }))}
            required
            label="Category"
            name="Category"
            size="small"
            type="text"
            fullWidth
            variant="outlined"
            disabled={isSubmitting}
            // error={error}
            // helperText={error ? 'Please enter a valid card name(min 3 char)' : ''}
          />
        </div>
        <div style={{ display: 'flex', gap: '12px', marginTop: '16px', justifyContent: 'end' }}>
          <Button disabled={isSubmitting} onClick={handleClose} sx={{ backgroundColor: '#19c25f' }} variant="contained">
            Cancel
          </Button>
          <Button disabled={isSubmitting} onClick={onSubmit} sx={{ backgroundColor: '#19c25f' }} variant="contained">
            Create
          </Button>
        </div>
      </Box>
    </Modal>
  );
}
